import React from "react";

function Process() {
  return (
    <section className="tc-process-style1">
      <div className="container">
        <div className="title mb-100 text-center">
          <h2 className="fsz-45">Tetra Yapıda Süreç Nasıl İşler </h2>
        </div>
        <div className="content">
          <div className="row">
            <div className="col-lg-5">
              <div className="info">
                <div
                  className="accordion wow fadeInUp slow"
                  id="accordionProcess"
                >
                  <div className="accordion-item">
                    <div className="accordion-header" id="headingOne">
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                      >
                        <span className="num"> 1 / </span>
                        <h3> Alan Projelendirme ve Tasarım </h3>
                      </button>
                    </div>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse show"
                      data-bs-parent="#accordionProcess"
                    >
                      <div className="accordion-body">
                        <div className="text">
                          Tetra Yapı, yeni bir arsa edindiğinde bölgenin
                          potansiyelini detaylı biçimde analiz eder. İmar
                          durumu, ulaşım ağı, çevre planları gibi unsurlar
                          değerlendirilir. Ardından hedef kitleye ve bölgenin
                          dinamiklerine uygun özgün bir proje konsepti
                          geliştirilir.Geliştirilen proje için gerekli tüm resmi
                          izinler eksiksiz ve hızlı bir şekilde alınır.
                          Belediyelerle ve ilgili kurumlarla koordinasyon
                          sağlanarak ruhsat süreci uzman kadro eşliğinde
                          yürütülür.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <div className="accordion-header" id="headingTwo">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                      >
                        <span className="num"> 2 / </span>
                        <h3> İnşaat ve Şantiye Yönetimi </h3>
                      </button>
                    </div>
                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionProcess"
                    >
                      <div className="accordion-body">
                        <div className="text">
                          Projenin her aşaması kalite standartlarına uygun
                          biçimde, deneyimli saha ekipleri tarafından titizlikle
                          yönetilir. Yapı güvenliği, malzeme kalitesi ve iş
                          planına sadakat ön planda tutulur.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <div className="accordion-header" id="headingThree">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                      >
                        <span className="num"> 3 / </span>{" "}
                        <h3> Satış ve Pazarlama Süreci</h3>
                      </button>
                    </div>
                    <div
                      id="collapseThree"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionProcess"
                    >
                      <div className="accordion-body">
                        <div className="text">
                          Tamamlanan projeler, Tetra Yapı’nın profesyonel
                          pazarlama ekibiyle hedef kitleye ulaştırılır. Proje
                          lansmanı, satış stratejileri ve müşteri ilişkileri bu
                          aşamada yönetilir.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <div className="accordion-header" id="headingFour">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFour"
                      >
                        <span className="num"> 4 / </span>{" "}
                        <h3>Teslimat ve Müşteri Memnuniyeti</h3>
                      </button>
                    </div>
                    <div
                      id="collapseFour"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionProcess"
                    >
                      <div className="accordion-body">
                        <div className="text">
                          Tetra Yapı, yalnızca yapılar inşa etmez; aynı zamanda
                          huzurlu bir yaşam teslim eder. Anahtar tesliminden
                          sonra da müşteri memnuniyetini sürdüren destek
                          hizmetleri sunulur.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <a
                  href="#"
                  className="butn border rounded-pill mt-80 color-orange1 border-orange1 hover-bg-orange1"
                >
                  <span>
                    Bir Toplantı Ayarla
                    <i className="small ms-1 ti-arrow-top-right"></i>
                  </span>
                </a>
              </div>
            </div>
            <div className="col-lg-4 offset-lg-2">
              <div className="img wow">
                <img src="/plsn.jpg" alt="" className="img-cover" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Process;
